<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add @click="toAddPage" v-if="permissionCodes.indexOf('014003001') !== -1"/>
        <button-cancel value="按住户退款" @cancel="toAddPage2" v-if="permissionCodes.indexOf('014003004') !== -1" style="margin-left: 10px;"/>
<!--        <button-add @click="toAddPage2" value="按住户退款" v-if="permissionCodes.indexOf('014003004') !== -1"/>-->
        <!-- <input-select :selectTitle="'缴费渠道'" style="margin-right: 10px;" selectWidth="120px" :selectData="payChannelList" @search="search" :selectKey="'payChannel'" /> -->
      </div>
      <div style="display: flex;justify-content: space-between;">
        <input-search placeholder="退款对象" @search="searchKey" />
        <button-export
          style="margin-left: 5px"
          :href="exportUrl"
          download="download.xls"
          v-if="permissionCodes.indexOf('014003003') !== -1"
          :beforeDownload="beforeDownload"
          value="导出"/>
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @confirmRefund="confirmRefund" :operationArr="operationArr" @seeExample="seeExample"/>

    <el-dialog
    title="关联账单"
    :visible.sync="dialogVisible"
    width="75%"
    :before-close="handleClose">
<!--    <div class="content">-->
<!--      <div>缴费对象:{{contenteData.payer}}</div>-->
<!--      <div style="margin:10px 0">缴费对象手机号:{{contenteData.phone}}</div>-->
<!--      <div>状态:{{contenteData.billStatusText}}</div>-->
<!--    </div>-->
      <table-main :selection="false" :tableHeight="500" :tableHead="tableHead2" :pagination="false" :tableData="tableData2" :hasOperation="false"/>
    <!-- <div>{{contenteData.phone}}</div> -->
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/CustomPayment";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nError, nSuccess } from "../../../utils/notice";
import ButtonCancel from "../../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonCancel,
    Breadcrumb
  },
  name: "refund-management",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧收费",
          name: "charge-items-management"
        },
        {
          value: "退款管理"
        }
      ],
      exportUrl: "",
      addPageName: "charge-items-management-add",
      tableHead: [
        {
          prop: "refundObj",
          label: "退款对象"
        },
        {
          prop: "paymentItemName",
          label: "收费项名称"
        },
        {
          prop: "chargeMode",
          label: "收费模式"
        },
        {
          prop: "chargeType",
          label: "收费类型"
        },
        {
          prop: "billAmount",
          label: "账单金额"
        },
        {
          prop: "refundAmount",
          label: "应退金额"
        },
        {
          prop: "actualRefundAmount",
          label: "实退金额"
        },
        {
          prop: "operator",
          label: "经办人"
        },
        {
          prop: "payChannelText",
          label: "关联账单",
          example: true
        },
        {
          prop: "refundTime",
          label: "退款时间"
        },
        {
          prop: "memo",
          label: "备注"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      payChannelList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "微信"
        },
        {
          key: "2",
          label: "支付宝"
        },
        {
          key: "3",
          label: "银行转账"
        },
        {
          key: "4",
          label: "现金"
        },
        {
          key: "5",
          label: "其他"
        }
      ],
      requestData: {
        searchKey: "",
        payChannel: ""
      },
      operationArr: ["confirmRefund"],

      currentBillData: {},
      dialogVisible: false,
      splitAccountCount: null,
      separateAccountData: [],
      contenteData: [],
      tableHead2:[
        {
          prop: "payer",
          label: "缴费对象"
        },        {
          prop: "phone",
          label: "手机号"
        },        {
          prop: "billStatusText",
          label: "状态"
        },      {
          prop: "enterpriseName",
          label: "退款住户"
        },          {
          prop: "chargeAmount",
          label: "支付金额"
        },         {
          prop: "payMethodText",
          label: "支付方式"
        },     {
          prop: "payTime",
          label: "缴费时间"
        },       {
          prop: "refundTime",
          label: "退款时间"
        },
      ],
      tableData2:[],
      // total2:0,
      requestData2:{
        pageNum:1,
        pageSize:10
      }
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportRefund}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}`;
    },
    toModifyPage(code) {
      this.$router.push({
        path: "/custom_payment_record_modify/" + code
      });
    },
    toAddPage() {
      this.$router.push({
        name: "refund-management-add"
      });
    },
    toAddPage2() {
      this.$router.push({
        name: "refund-add-by-company"
      });
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getRefundManagementPage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            // data.map(v => {
            //   v.paymentItemName = v.relationBillInfo.paymentItemName;
            //   v.chargeMode = v.relationBillInfo.chargeMode;
            //   v.chargeType = v.relationBillInfo.chargeType;
            // });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    confirmRefund(code) {
      this.$router.push({
        path: "/refund_management_confirm/" + code.code
      });
    },
    seeExample(data) {
      this.requestData2.code=data.code
      this.$axios.get(api.getRelationBill+'/'+data.code).then(res=>{
        this.tableData2=res.data.data
        this.tableData2.map(v=>{
         if(v.payMethod=='1'){
           v.payMethodText='微信'
         }else if(v.payMethod=='2'){
           v.payMethodText='支付宝'
         }else if(v.payMethod=='3'){
           v.payMethodText='银行转账'
         }else if(v.payMethod=='4'){
           v.payMethodText='现金'
         }else if(v.payMethod=='5'){
           v.payMethodText='其他'
         }
         if(v.billStatus=='1'){
           v.billStatusText="已缴费"
         }else if(v.billStatus=='2'){
           v.billStatusText="已退款"
         }else if(v.billStatus=='0'){
           v.billStatusText="未缴费"
         }
        })
        // this.total2=res.data.data.total
        // if (this.contenteData.billStatus == "1") {
        //   this.contenteData.billStatusText = "已缴费";
        // } else if (this.contenteData.billStatus == "0") {
        //   this.contenteData.billStatusText = "未缴费";
        // } else if (this.contenteData.billStatus == "2") {
        //   this.contenteData.billStatusText = "已退款";
        // }
        // console.log(this.contenteData)
      }).catch(errorHandler("获取信息失败"))
      // this.contenteData = data.relationBillInfo;
      // if (this.contenteData.billStatus === "1") {
      //   this.contenteData.billStatusText = "已缴费";
      // } else if (this.contenteData.billStatus === "0") {
      //   this.contenteData.billStatusText = "未缴费";
      // } else if (this.contenteData.billStatus === "2") {
      //   this.contenteData.billStatusText = "已退款";
      // }
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    changePagination2(data) {
      this.requestData2.pageNum = data[0];
      this.requestData2.pageSize = data[1];
      this.getDetailPage();
    },
  },
  watch: {}
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 140px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin: 40px 0;
  display: flex;
  justify-content: space-between;
}
.content {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  font-size: 14px;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/CustomPayment/RefundManagement/RefundManagement.vue